export const PAGE_ID = {
    EVENT: 'EP',
    GOOD: 'GP',
    EXHIBITION: 'DP',
    MQNA: 'MQNA',
    CQNA: 'CQNA',
    GIFTSHOW: 'GIFTSHOW',
    ORDER: 'ORDER',
    CUSTOMER_QNA: 'CUSTOMER_QNA',
  };
